export default "__VITE_PUBLIC_ASSET__5d80cf9c__"